export default "__VITE_ASSET__ui2cSJY1__";